export enum SplitInvoiceTypes {
  first = 'first',
  second = 'second',
}
